import { Injectable } from "@angular/core";
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class ReconnectionService {
    private reconnecedFlag = new BehaviorSubject<boolean>(false);

    result = this.reconnecedFlag.asObservable();

    constructor() { }

    setValue(state: boolean) {
        this.reconnecedFlag.next(state);
    }

    getValue() {
        return this.reconnecedFlag.getValue();
    }
}


// WEBPACK FOOTER //
// node_modules/ngc-webpack??ref--0-3!./node_modules/angular2-template-loader!./node_modules/tslint-loader??ref--7-0!./src/services/reconnection.service.ts